import { render, staticRenderFns } from "./OnneContatoTelefone.vue?vue&type=template&id=6b66cd15&scoped=true&"
import script from "./OnneContatoTelefone.vue?vue&type=script&lang=js&"
export * from "./OnneContatoTelefone.vue?vue&type=script&lang=js&"
import style0 from "./OnneContatoTelefone.vue?vue&type=style&index=0&id=6b66cd15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b66cd15",
  null
  
)

export default component.exports